import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import OmanMofaMain from "./OmanMofaMain";
const OmanMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <OmanMofaMain />
    </div>
  );
};

export default OmanMofa;
